import React from 'react'
import styled from 'styled-components'

import { useMedia } from '@/utils/use-media'
import ShapesImage from '@/assets/images/shapes/intro.svg'
import { mobile } from '@/utils/media-query'
import { useIsMounted } from '@/utils/use-is-mounted'

import { SdkExamplesBlock } from './sdk-examples-block'
import { SDKIntroBlock } from './sdk-intro-block'
import { Section } from './section'
import { Shapes } from './shapes'
import { UseCasesBlock } from './use-cases-block'

const StyledSection = styled(Section)`
  width: fit-content;
  max-width: 1356px;

  @media ${mobile.query} {
    width: auto;
  }
`

const Circle = styled(Shapes)`
  top: initial;
  left: initial;
  transform: translateY(20px);
  height: 350px;

  &::before {
    background-position-y: 0;
  }
`

const Line = styled(Shapes)`
  top: initial;
  left: initial;
  height: 260px;
  transform: translate(460px, 1315px) scaleX(1.5);
  width: 508px;

  &::before {
    background-position-y: -650px;
    background-position-x: -1230px;
  }
`

export const IntroSection: React.FC = () => {
  const isMobileScreen = useMedia(mobile.query, false)
  const isMounted = useIsMounted()

  return (
    <StyledSection>
      <SDKIntroBlock />
      {isMounted && !isMobileScreen && (
        <>
          <Circle source={ShapesImage} />
          <Line source={ShapesImage} />
        </>
      )}
      <UseCasesBlock />
      <SdkExamplesBlock />
    </StyledSection>
  )
}
